import { IFiltersMaintenancePackages } from '../components/types';

/**
 * Returns the default lead filters for a given lead type.
 *
 * @returns {IFiltersMaintenancePackages}
 */
export const getDefaultMaintenancePackagesFilters = () => ({
    page: 0,
    limit: 50,
    name: [],
    'details.title': [],
    stores: [],
    isActive: '',
    createdAt: null,
    updatedAt: '',
    isSearching: false,
    isTabsEnabled: false,
    tabValue: '',
    isQueryEnabled: false,
    query: '',
});
